










































import { ItemDaVenda } from '@/models'
import { chaveDeNotaDigitadaEhValida, normalizarChaveDeNota } from '@/shareds/fiscal'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class DialogoDeVincularChaveComItem extends Vue {
itensDaVenda: ItemDaVenda[] = []
mostrar = false

mostra(itens: ItemDaVenda[], mostra: boolean) {
	this.itensDaVenda = itens
	this.mostrar = mostra
}

confirmar() {
	if (this.ehDevolucaoDeTransferencia) {
		this.itensDaVenda.forEach(item => {
			item.chaveNotaOrigem = normalizarChaveDeNota(item.chaveNotaOrigem)
		})
	}
	this.mostrar = false
}

get ehDevolucaoDeTransferencia() {
	return VendaModule.emissaoEntradaAtual?.tipoDeTransacao === 'Devolução de Transferência'
}

get regrasDaChave() {
	return [
		(v: any) => !this.ehDevolucaoDeTransferencia
			|| chaveDeNotaDigitadaEhValida(v)
			|| 'A chave deve ter 44 dígitos, sem o prefixo NFe',
	]
}

get itensSemChave() {
	return this.itensDaVenda.filter(i => this.ehDevolucaoDeTransferencia
		? !chaveDeNotaDigitadaEhValida(i.chaveNotaOrigem)
		: i.chaveNotaOrigem === null) || []
}

}
